// import md5 from 'js-md5'
import { isNull } from 'lodash-es';
import {useUserStore} from "@/store/module/user";
import {md5} from "js-md5";
// 对象转数组，并排序
const objectToArr = function (object, addkey = '') {
    let arrs = {}
    for (let i in object) {
        if (typeof object[i] !== 'undefined') {
            let newkey = addkey + (addkey === '' ? i : '[' + i + ']')
            if (typeof object[i] !== 'object' || isNull(object[i])) {
                arrs[newkey] = object[i]
            } else {
                Object.assign(arrs, objectToArr(object[i], newkey));
            }
        }
    }
    let sortKey = Object.keys(arrs).sort()
    let newObj = {}// 创建一个新的对象，用于存放排好序的键值对

    // 此处不能使用for..in
    sortKey.forEach(function (val) {
        newObj[val] = arrs[val]// 向新创建的对象中按照排好的顺序依次增加键值对
    })
    return newObj
}

// 对象转字符串
function objectToString(object, str = '') {
    for (var i in object) {
        if (typeof object[i] !== 'object' || isNull(object[i])) {
            str += i + '=' + (isNull(object[i]) ? '' : object[i]) + '&'
        } else {
            str += objectToString(object[i])
        }
    }
    return str
}
function getMilliseconds() {
    let date = new Date();     //将时间格式转为字符串
    return Date.parse(date.toString());
}
/**
 * 计算校验位（使用模10算法）
 * @param {string} digits 数字字符串
 * @returns {string} 校验位
 */
const calculateCheckDigit = (digits) => {
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
        let digit = parseInt(digits[i], 10);
        // 奇数位（从1开始数）权重为2
        if ((i + 1) % 2 === 1) {
            digit *= 2;
            // 如果乘积大于9，则减去9
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
    }

    // 计算校验位
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit.toString();
}
/**
 * 获取带校验位的毫秒级时间戳
 * @returns {string} 带校验位的时间戳
 */
const getTimestampWithCheckDigit = () =>{
    // 获取毫秒级时间戳
    const milliseconds = getMilliseconds();

    // 确保时间戳至少有12位
    const timestampStr = milliseconds.toString();

    // 取前12位
    const firstTwelveDigits = timestampStr.substring(0, 12);

    // 计算校验位
    const checkDigit = calculateCheckDigit(firstTwelveDigits);

    // 返回带校验位的时间戳
    return firstTwelveDigits + checkDigit;
}
export const makeSign = function (object) {
    object.timestamp = getTimestampWithCheckDigit();
    const newObject = objectToArr(object)
    let signString = objectToString(newObject)
    signString = signString.slice(0, -1)
    object.sign = md5(md5(signString + object.timestamp) + object.timestamp);
    return object
}

/**
 * 判断单条或者多条权限
 * @param auth
 * @returns {boolean}
 */
export function authCheck(auth) {
    const userStore = useUserStore()
    if (!userStore.token){
        return false
    }
    if (userStore.authRule.length === 0) {
        userStore.loadAuthRule()
    }
    if(typeof auth == 'string') return Object.values(userStore.authRule).indexOf(auth) >= 0;
    let result = true;
    for (let i = 0; i < auth?.length; i++) {
        result = Object.values(userStore.authRule).indexOf(auth[i]) >= 0;
        if(!result){
            return false
        }
    }
    return result;
}

export async function authCheckSave(auth) {
    const userStore = useUserStore()
    if (!userStore.token){
        return false
    }
    if (userStore.authRule.length === 0) {
        await userStore.loadAuthRule()
    }
    if(typeof auth == 'string') return Object.values(userStore.authRule).indexOf(auth) >= 0;
    let result = true;
    for (let i = 0; i < auth?.length; i++) {
        result = Object.values(userStore.authRule).indexOf(auth[i]) >= 0;
        if(!result){
            return false
        }
    }
    return result;
}

export function getUserInfo() {
    const userStore = useUserStore()
    if (userStore.userInfo.length === 0) {
        userStore.updateUserInfo()
    }
    return userStore.userInfo;
}
export function logout() {
    const userInfoStore = useUserStore()
    userInfoStore.$reset()
    localStorage.removeItem('user')
}
